export default __webpack_public_path__ + "images/10_2_image.jpg";